import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/easm-settings/edit/$id/$organizationId')({
  beforeLoad: () => getTitleContextSlice('Edit Profile'),
});
